<style>
    .ue_track_full {
        width: 100%;
        padding-top: 38%;
        background-repeat: no-repeat;
        margin: auto;
        background-position: center;
        background-size: contain!important;
    }
    .image_box_image {
        width: 100%;
    }
</style>
<script>
    import {mutations, tabImagesArray} from '../mainStore.js';
    export let track

</script>
<div class="ue_track_full" style="background: url({track.full_image}) no-repeat center; background-size: contain;"/>
{#if (track.detail_image)}
<img src="{track.detail_image}" alt="" class="image_box_image">
{/if}
